import React, { useEffect, useState } from "react";
import { CardBody, CardHeader, Card, Form, FormGroup, Input, Spinner } from "reactstrap";
import DataTable, { createTheme } from "react-data-table-component";
import { Col, PreviewAltCard, Row } from "../../../components/Component";
createTheme(
  "customDark",
  {
    text: {
      primary: "#FFFFFF",
      secondary: "#CCCCCC",
    },
    background: {
      default: "#1e1e1e",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#30363d",
    },
    action: {
      button: "rgba(139, 139, 139, 0.54)",
      hover: "rgba(255, 255, 255, 0.08)",
      disabled: "rgba(255,255,255,0.12)",
    },
  },
  "dark"
);

// Expandable Row Component
const ExpandableRowComponent = ({ data, columns }) => {
  if (!data.subcategory || data.subcategory.length === 0) return null;
  return (
    <div style={{ padding: "10px", color: "white" }}>
      <DataTable
        columns={columns}
        data={data.subcategory}
        dense
        expandableRows
        expandableRowDisabled={(row) => !row.subcategory || row.subcategory.length === 0}
        expandableRowsComponent={(props) => <ExpandableRowComponent {...props} columns={columns} />}
        noHeader
        noTableHead
      />
    </div>
  );
};

const MyDataTable = ({ data = [], columns, title, isLoading, sub }) => {
  const [filterText, setFilterText] = useState("");
  const filteredData = data?.filter((item) =>
    Object?.values(item)?.some(
      (value) => typeof value === "string" && value.toLowerCase().includes(filterText.toLowerCase())
    )
  );

  return (
    <Row className="g-gs mt-1g-gs mt-1">
      <Col sm="12">
        <PreviewAltCard>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5>{title}</h5>
              <div className="search-box d-flex justify-content-end">
                <Form className="theme-form">
                  <FormGroup className="form-group d-flex align-items-center">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="Search..."
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                    />
                    <i className="fa fa-search ms-2"></i>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <div className="data-table-container">
              <DataTable
                className="my-custom-table"
                columns={columns}
                data={filteredData}
                progressPending={isLoading}
                pagination
                paginationResetDefaultPage={false}
                progressComponent={
                  <Spinner color="primary" style={{ height: "3rem", width: "3rem" }} type="grow">
                    Loading...
                  </Spinner>
                }
                subHeader={false}
                persistTableHead
                striped
                responsive
                highlightOnHover
                paginationRowsPerPageOptions={[25, 50, 100, 500]}
                paginationPerPage={25}
                expandableRows={sub}
                expandableRowDisabled={(row) => !row.subcategory || row.subcategory.length === 0}
                expandableRowsComponent={(props) => <ExpandableRowComponent {...props} columns={columns} />}
              />
            </div>
          </CardBody>
        </PreviewAltCard>
      </Col>
    </Row>
  );
};

export default MyDataTable;
